import { Checkbox } from "@mantine/core";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setShowNotesOnSummary } from "src/redux/slices/preferencesSlice";

const ShowNotes = () => {
  const { showNotesOnSummary } = useSelector(state => state.preferencesSlice);

  const dispatch = useDispatch();

  return (
    <>
      <span>Show Notes</span>
      <Checkbox
        onChange={() => {
          dispatch(setShowNotesOnSummary(!showNotesOnSummary));
          localStorage.setItem(
            "showNotes",
            !showNotesOnSummary ? "true" : "false",
          );
        }}
        checked={showNotesOnSummary}></Checkbox>
    </>
  );
};

export default ShowNotes;
